import styled from "styled-components";

export const ContainerInputs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ContainerInput = styled.div`
  position: relative;
  /* margin: 10px 0; */
  width: 32%;

  @media (max-width: 820px) {
    width: 95%;
  }
`;
